/*
 * Quick add (+) buttons on product cards.
 * Adds the card's single variant with /cart/add.js, then fires Impulse's own
 * 'ajaxProduct:added' event so the cart drawer refreshes and opens as for a normal add.
 * Without JavaScript the form posts to /cart/add as usual.
 */
(function () {
  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form.matches || !form.matches('[data-kd-quick-add]')) return;
    evt.preventDefault();

    var btn = form.querySelector('button');
    if (btn.disabled) return;
    btn.disabled = true;
    btn.classList.add('is-loading');

    fetch(window.theme && theme.routes ? theme.routes.cartAdd : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(form.elements.id.value), quantity: Number(form.elements.quantity.value) || 1 }]
      })
    })
      .then(function (res) {
        return res.json().then(function (body) { return { ok: res.ok, body: body }; });
      })
      .then(function (result) {
        if (!result.ok || result.body.status) {
          // Sold out or not addable: send the shopper to the product page instead.
          var link = form.closest('.grid-product__content').querySelector('.grid-product__link');
          if (link) window.location.href = link.href;
          return;
        }
        var items = result.body.items || [];
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 1500);
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: items[0], items: items, addToCartBtn: btn }
        }));
        if (!window.theme || theme.settings.cartType !== 'drawer') {
          window.location.href = window.theme ? theme.routes.cartPage : '/cart';
        }
      })
      .catch(function () {
        form.submit();
      })
      .finally(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
  });
})();
